import React from "react";
import { Autoplay } from "swiper";
// import headerBackgroundImage from "./card-background-2.png";
export const VideoIframe = ({ src, title }) => {
  return (
    <iframe
      width="290"
      height="260"
      src={src}
      title={title}
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
      className="rounded-xl"
    ></iframe>
  );
};
function News() {
  return (
    // <div className='' style={{ backgroundImage: `url(${headerBackgroundImage})` }}>
    <div className="py-8">
      {/* <div>
                <img className='w-full' src='newimage/banner/aboutBrother.svg'></img>
            </div> */}
      <div>
        {/* <div className="p-2 mx-[28%] items-center flex-col justify-center font-serif text-center text-blue-800 text-2xl bg-[aliceblue] rounded-full">
          <div className="h-[2px] my-auto mx-2 w-20 bg-blue-800 inline-block"></div>
          OUR GLOBAL MISSION
          <div className="h-[2px] my-auto w-20 bg-blue-800 inline-block mx-2"></div>
        </div> */}
         <h2 className="border-b-2 border-[gainsboro] w-[12%] mx-auto items-center flex-col justify-center font-serif text-center text-blue-800 text-[26px] uppercase rounded-2xl">
         News      
         </h2>
        <div className="grid gap-6 px-6 pt-10 xs:grid-cols-1 md:grid-cols-4">
        <VideoIframe
          src="https://www.youtube.com/embed/WL4TIMaCUNU"
          title="News Divine - May 2023 | Sant Nirankari Mission | Universal Brotherhood"
        />
        <VideoIframe
          src="https://www.youtube.com/embed/0-gF5lh7brE"
          title="News Divine - November 2023 | Sant Nirankari Mission | Universal Brotherhood"
        />
        <VideoIframe
          src="https://www.youtube.com/embed/pWjlmeNdYIY"
          title="News Divine - July 2023 | Sant Nirankari Mission | Universal Brotherhood"
        />
        <VideoIframe
          src="https://www.youtube.com/embed/x5JoKpcf0wY"
          title="News Divine - June 2023 | Sant Nirankari Mission | Universal Brotherhood"
        />
        </div>
        <div className="grid gap-6 px-6 pt-10 xs:grid-cols-1 md:grid-cols-4">
        <iframe width="290" height="260" src="https://www.youtube.com/embed/FTwuIsVM8eI" title="News Divine - September 2023 | Sant Nirankari Mission | Universal Brotherhood" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        <iframe width="290" height="260" src="https://www.youtube.com/embed/3fJBqIhGdwg" title="News Divine - August 2023 | Sant Nirankari Mission | Universal Brotherhood" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        <iframe width="290" height="260" src="https://www.youtube.com/embed/A8g6c71DOLk" title="News Divine July 2019||Sant Nirankari Mission||Nirankari||News Divine||Universal Brotherhood||" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        <iframe width="290" height="260" src="https://www.youtube.com/embed/eicZjXRl940" title="News Divine | January 2023 | Sant Nirankari Mission | Universal Brotherhood" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  );
}

export default News;
